const router = [
  {
    path: '/mowLawn',
    name: 'mowLawn',
    component: () => import('@/views/setting/mowLawn/Map.vue'),
    meta: {
      title: '割草机',
      hasBack: false
    }
  },
  // 设备详情
  {
    name: 'mowLawnDetail',
    path: '/mowLawn/deviceDetail/:projectId/:deviceNumber',
    component: () => import('@/views/setting/mowLawn/Detail.vue'),
    meta: {
      title: '割草机查看',
      activeMenu: '/mowLawn'
    }
  }
]

export default router
